/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Topic_Delete_SuccessInputs */

const en_toast_topic_delete_success = /** @type {(inputs: Toast_Topic_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic deleted successfully`)
};

const nl_toast_topic_delete_success = /** @type {(inputs: Toast_Topic_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderwerp succesvol verwijderd`)
};

/**
* | output |
* | --- |
* | "Topic deleted successfully" |
*
* @param {Toast_Topic_Delete_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_topic_delete_success = /** @type {((inputs?: Toast_Topic_Delete_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Topic_Delete_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_topic_delete_success(inputs)
	return en_toast_topic_delete_success(inputs)
});